export default "__VITE_ASSET__BfZh68Zo__"